import type { FdlRecord } from '@treasury/FDL/field';
import { ListeningElementMixin } from '@treasury/omega/components';
import '@treasury/omega/components/omega-button';
import '@treasury/omega/components/omega-field';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

const ListeningElement = ListeningElementMixin(LitElement);
const tagName = 'check-lookup-filters';
@customElement(tagName)
export class CheckLookupFilters extends ListeningElement {
    @property()
    private filterRecord?: FdlRecord;

    render() {
        return html`<section id="filters">
            <omega-field field="accounts" .record=${this.filterRecord}></omega-field>
            <omega-field field="dateRange" .record=${this.filterRecord}></omega-field>
            <omega-field field="checkNumber" .record=${this.filterRecord}></omega-field>
            <omega-field field="amountRange" .record=${this.filterRecord}></omega-field>
        </section>`;
    }

    static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
                #filters {
                    padding: 16px;
                }
                omega-field {
                    padding: 10px 10px;
                }
            `,
        ];
    }
}
